export default "__VITE_ASSET__CO7cN0wb__"